import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTenant } from '../contexts/TenantContext';
import LoadingSpinner from './LoadingSpinner';
import TenantErrorScreen from './TenantErrorScreen';

const TenantGuard = () => {
    const location = useLocation();
    const { tenantId, loading, error, needsTenantSelection } = useTenant();

    // Loading tenant
    if (loading) {
        return <LoadingSpinner />;
    }

    // Needs tenant selection - redirect to selection page
    // Ensure we don't redirect if we are already there (though this guard shouldn't wrap selection page)
    if (needsTenantSelection || !tenantId) {
        // Prevent infinite redirects if misconfigured
        if (location.pathname === '/select-tenant') {
            return <Outlet />;
        }
        return <Navigate to="/select-tenant" replace />;
    }

    // Tenant error - show error screen
    if (error) {
        return <TenantErrorScreen error={error} />;
    }

    // All good - render protected content
    return <Outlet />;
};

export default TenantGuard;
